export default __webpack_public_path__ + "static/media/un-checked.4451bbb1.svg";